import React, { FC } from 'react';
import Slider from 'react-slick';
import { TCarouselForEE } from '../types/herocarousel.types';
import HeroCarouselSlide from './heroCarouselSlide';

const CarouselForEE: FC<TCarouselForEE> = (props) => {
  const { id, isEE, carouselSlide, rendering, headingTag } = props;
  const settings = {
    infinite: !isEE,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <Slider {...settings}>
      {carouselSlide?.map((itemFields) => (
        <div className="slide" key={itemFields?.title.value}>
          <HeroCarouselSlide fields={itemFields} rendering={rendering} isEEActive={isEE} slideTitleTag={headingTag} id={id} />
        </div>
      ))}
    </Slider>
  );
};

export default CarouselForEE;
